import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

export default function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleClientLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const res = await api.clientLogin({ email, password });
      if (res.token) {
        localStorage.setItem('maxmark_client_token', res.token);
        navigate('/dashboard');
      }
    } catch (err) {
      setError(err.message || 'Login failed. Please check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#030509] flex items-center justify-center px-4 pt-24 pb-12">
      <div className="max-w-md w-full bg-[#050506] p-8 md:p-12 rounded-[2.5rem] border border-[#242832] shadow-2xl relative overflow-hidden">

        {/* Glow accent */}
        <div className="absolute -top-24 -left-24 w-48 h-48 bg-blue-600/10 rounded-full blur-3xl pointer-events-none"></div>
        <div className="absolute -bottom-24 -right-24 w-48 h-48 bg-blue-600/10 rounded-full blur-3xl pointer-events-none"></div>

        <div className="text-center mb-8 relative z-10">
          <h1 className="text-3xl font-serif font-bold text-white mb-2 leading-tight">Client Intelligence Portal</h1>
          <p className="text-zinc-500 text-xs font-light">Access competitor monitors, creative audits, and strategic reports.</p>
        </div>

        {error && (
          <div className="mb-6 p-4 bg-red-900/20 border border-red-900/30 text-red-400 text-xs rounded-xl">
            {error}
          </div>
        )}

        <div className="space-y-6 relative z-10">
          <form onSubmit={handleClientLogin} className="space-y-4">
            <div className="space-y-2">
              <label className="text-[10px] font-bold text-zinc-500 uppercase tracking-widest ml-1">Work Email</label>
              <input
                type="email"
                className="w-full bg-black border border-[#242832] text-white text-sm rounded-xl px-4 py-3 focus:outline-none focus:border-[#2F6BFF] transition-colors"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="you@company.com"
                required
              />
            </div>

            <div className="space-y-2">
              <div className="flex justify-between items-center px-1">
                <label className="text-[10px] font-bold text-zinc-500 uppercase tracking-widest">Password</label>
              </div>
              <input
                type="password"
                className="w-full bg-black border border-[#242832] text-white text-sm rounded-xl px-4 py-3 focus:outline-none focus:border-[#2F6BFF] transition-colors"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="••••••••"
                required
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-[#2F6BFF] hover:bg-[#1a54ff] text-white py-4 rounded-xl font-bold uppercase tracking-widest text-xs transition-all disabled:opacity-50 shadow-lg shadow-blue-600/20"
            >
              {loading ? 'Authenticating Workspace...' : 'Secure Sign In'}
            </button>
          </form>
        </div>

        <div className="mt-8 pt-8 border-t border-[#242832] text-center relative z-10">
          <p className="text-[10px] font-bold uppercase tracking-widest text-zinc-600">
            Need Workspace Access? <a href="mailto:info@maxmarkagency.com" className="text-[#2F6BFF] hover:underline ml-1">Contact Support</a>
          </p>
        </div>
      </div>
    </div>
  );
}
